import { useState } from "react";
import { baseAxios } from "../apis";

/**
 * Hits this project's own /api/csrf-cookie/ to get a csrftoken cookie set,
 * then reads it back so it can be sent as the X-CSRFToken header on writes.
 */
export function useCsrfToken() {
  const [csrfToken, setCsrfToken] = useState("");

  const fetchCsrfToken = async () => {
    try {
      const resp = await baseAxios.get("/api/csrf-cookie/", {
        withCredentials: true,
      });
      const tokenFromHeader =
        resp.headers["x-csrftoken"] ||
        (document.cookie.match(/csrftoken=([^;]+)/) || [])[1] ||
        "";

      if (tokenFromHeader) {
        setCsrfToken(tokenFromHeader);
        return tokenFromHeader;
      }
      return "";
    } catch (err) {
      console.error("Error fetching CSRF token:", err);
      return "";
    }
  };

  return {
    csrfToken,
    fetchCsrfToken,
  };
}
